interface IProfileRouter {
  path: string;
  redirectTo404: Redirect;
}

export type Redirect = (module: string) => void;
export type RedirectOrNull = Redirect | null;

export enum routeName {
  ROOT = 'profile',
}

export default IProfileRouter;



// WEBPACK FOOTER //
// ./src/pages/profile/router/types.ts